import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles } from "@cinch-labs/design-system";
import cx from "classnames";
import Image from "next/image";
import styles from "./review-card.module.css";
import { StarRating } from "../star-rating";
var ref;
export var ReviewCard = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, image = param.image, _starRating = param.starRating, starRating = _starRating === void 0 ? "" : _starRating, _snippet = param.snippet, snippet = _snippet === void 0 ? "" : _snippet, _featured = param.featured, featured = _featured === void 0 ? false : _featured;
    /*#__PURE__*/ return _jsxs("article", {
        className: cx(styles.root, _define_property({}, styles.topCard, featured)),
        "data-featured": featured,
        "data-uid": title,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cx(styles.imageContainer, _define_property({}, styles.featured, featured)),
                children: /*#__PURE__*/ _jsx(Image, {
                    className: styles.image,
                    alt: (ref = image === null || image === void 0 ? void 0 : image.alt) !== null && ref !== void 0 ? ref : "",
                    src: (image === null || image === void 0 ? void 0 : image.filename) || "".concat(process.env["STAGE_NAME"] === "local" ? "" : process.env.STAGE_URL, "/image-coming-soon.svg"),
                    layout: "fixed",
                    width: featured ? 400 : 250,
                    height: featured ? 253 : 158,
                    priority: featured
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        type: featured ? TextStyles.vehicleTitle : TextStyles.mainTitle,
                        element: "h2",
                        className: styles.title,
                        lineHeight: "display",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(StarRating, {
                        starRating: +starRating
                    }),
                    snippet && /*#__PURE__*/ _jsx(Text, {
                        element: "p",
                        className: styles.snippet,
                        children: snippet
                    })
                ]
            })
        ]
    });
};
